import getApi, {createApiAsyncThunk, createWrapper} from '@web/helpers/api'

import {GetFamilyPayPaymentInfoParams, GetFamilyPayPaymentInfoResponse} from './interfaces'

const BaseUrl: Record<'MALL_CHECKOUT' | 'SELLER_CHECKOUT' | 'EASY_BOOK_CHECKOUT', string> = {
    MALL_CHECKOUT: '/orderApi/orderSheet/mall',
    SELLER_CHECKOUT: '/orderApi/orderSheet/seller',
    EASY_BOOK_CHECKOUT: '/orderApi/orderSheet/easyBooking',
}

export const getFamilyPayPaymentInfo = createApiAsyncThunk<
    GetFamilyPayPaymentInfoResponse,
    GetFamilyPayPaymentInfoParams
>('familyPay/getFamilyPayPaymentInfo', async ({orderAmount, pageSet, orderSheetId}) => {
    const api = getApi(BaseUrl[pageSet])

    const data = await createWrapper<GetFamilyPayPaymentInfoResponse>(
        api.get('/familyPayPaymentInfo', {params: {payAmount: orderAmount, orderSheetId}}),
    )

    return data
})
